import { ApiError } from "../generated"
import { Requester, Request, Result, Data } from "./types"

const namedErrors = [`MALFORMED`, `INVALID`, `FORBIDDEN`, `AUTH`, `NOT_FOUND`, `VEHICLE_NOT_MATCHED_TO_BAND`]

export type CreateRequest = <I, O>(requester: Requester<I, O>) => Request<I, O>

export const createRequest: CreateRequest = (requester) => async (input, getToken) =>
  requester(input, getToken)
    .then(toOk)
    .catch((e) => toErr(e))

const toOk = <O>(data: O): Result<O> => ({ tag: `ok`, data })

const isNamedError = (err: ApiError): boolean => {
  if (err instanceof ApiError) {
    return namedErrors.includes(err.body.type)
  }
  return false
}

const toErr = <O>(err: unknown): Result<O> => {
  if (err instanceof ApiError && isNamedError(err)) {
    return { tag: `err`, error: err.body, data: undefined }
  }
  return {
    tag: `err`,
    error: {
      type: `UNKNOWN`,
      payload: err,
    },
    data: undefined,
  }
}

type GetAllPages = <I, O>(
  paginatedRequest: Request<I, Data<O>>,
  getToken: () => Promise<string>,
  input: I,
  initial?: Array<O>
) => Promise<Result<Array<O>>>

export const getAllPages: GetAllPages = async (paginatedRequest, getToken, input, initial = []) => {
  const response = await paginatedRequest(input, getToken)
  if (response.tag === `err`) {
    return toErr(response)
  }
  const entries = [...initial, ...response.data.items]
  if (response.data?.next) {
    return getAllPages(paginatedRequest, getToken, { ...input, after: response.data.next }, entries)
  }
  return toOk(entries)
}
